import { c as _c } from "react/compiler-runtime";
import React, { FC } from 'react';
export const ToggleIcon: FC<{
  isToggled: boolean;
}> = t0 => {
  const $ = _c(7);
  const {
    isToggled
  } = t0;
  const t1 = isToggled ? "#2CD1A0" : "#727D9F";
  let t2;
  if ($[0] !== t1) {
    t2 = <rect y="0.5" width="35" height="20" rx="10" fill={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isToggled ? 25 : 10;
  let t4;
  if ($[2] !== t3) {
    t4 = <circle cx={t3} cy="10.5" r="8" fill="white" />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t4) {
    t5 = <svg width="35" height="21" viewBox="0 0 35 21" xmlns="http://www.w3.org/2000/svg">{t2}{t4}</svg>;
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};